


import React, { useState, useEffect, useRef, useCallback } from 'react';
// FIX: Use relative path to resolve types module.
import { View, UserSettings, Child, QuickMenuItemKey, ALL_QUICK_MENU_ITEMS_CONFIG } from '../../types';
import { 
    BoltIcon, 
    ArrowDownIcon, 
    AcademicCapIcon, 
    UserGroupIcon, 
    UserCircleIcon,
    DocumentTextIcon, 
    PresentationChartBarIcon, 
    QuestionMarkCircleIcon, 
    Square2StackIcon,
    FlagIcon,
    ChatBubbleLeftRightIcon,
    ScrollIcon,
    ChatBubbleBottomCenterTextIcon,
    PuzzlePieceIcon,
    ClipboardDocumentListIcon,
    XMarkIcon,
    BeakerIcon,
    ShieldCheckIcon,
    MagnifyingGlassIcon,
    DocumentDuplicateIcon,
    HomeIcon,
    LightBulbIcon,
    SparklesIcon,
    ChevronLeftIcon,
} from './Icons';

interface FloatingMenuProps {
    user: UserSettings;
    onNavigate: (view: View, payload?: object) => void;
    onUpdateSettings: React.Dispatch<React.SetStateAction<UserSettings>>;
    onSwitchRole?: (role: 'teacher' | 'parent') => void;
    activeRoleConfig: {
        role: string;
        accountRole: string;
        isTeacher: boolean;
        isParent: boolean;
        isStudent: boolean;
        isGuest: boolean;
        canSwitchRole: boolean;
        isRoleSwitched: boolean;
        dashboardView: View;
        dashboardPath: string;
        dashboardLabel: string;
        features: {
            showTeacherTools: boolean;
            showParentTools: boolean;
            showStudentTools: boolean;
            showCreative: boolean;
            showAssistant: boolean;
            showAITools: boolean;
            showEntertainment: boolean;
            homeworkLabel: string;
        };
    };
}

type FloatingQuickMenuItem = {
    key: string;
    label: string;
    view: View | string;
    icon: React.ReactNode;
    payload?: object;
    disabled?: boolean;
    disabledReason?: string;
};

const ALL_QUICK_MENU_ITEMS: Partial<Record<QuickMenuItemKey, FloatingQuickMenuItem>> = {
    [QuickMenuItemKey.TeacherTools]: { key: QuickMenuItemKey.TeacherTools, label: 'Bảng điều khiển', view: View.TeacherTools, icon: <AcademicCapIcon className="h-5 w-5 text-teal-600" /> },
    [QuickMenuItemKey.LessonPlanCreator]: { key: QuickMenuItemKey.LessonPlanCreator, label: 'Tạo Giáo án', view: View.LessonPlanCreator, icon: <DocumentTextIcon className="h-5 w-5 text-blue-500" /> },
    [QuickMenuItemKey.SlideCreator]: { key: QuickMenuItemKey.SlideCreator, label: 'Tạo Trình chiếu', view: View.SlideCreator, icon: <PresentationChartBarIcon className="h-5 w-5 text-green-500" /> },
    [QuickMenuItemKey.QuizCreator]: { key: QuickMenuItemKey.QuizCreator, label: 'Tạo Bài kiểm tra', view: View.QuizCreator, icon: <QuestionMarkCircleIcon className="h-5 w-5 text-purple-500" /> },
    [QuickMenuItemKey.OralQuizCreator]: { key: QuickMenuItemKey.OralQuizCreator, label: 'Kiểm tra kiến thức', view: View.OralQuizCreator, icon: <QuestionMarkCircleIcon className="h-5 w-5 text-fuchsia-500" /> },
    [QuickMenuItemKey.HomeworkCreator]: { key: QuickMenuItemKey.HomeworkCreator, label: 'Bài tập & ôn tập', view: View.HomeworkCreator, icon: <ClipboardDocumentListIcon className="h-5 w-5 text-yellow-500" /> },
    [QuickMenuItemKey.GameCreator]: { key: QuickMenuItemKey.GameCreator, label: 'Tạo trò chơi', view: View.GameCreator, icon: <BoltIcon className="h-5 w-5 text-orange-500" /> },
    [QuickMenuItemKey.ActivityCreator]: { key: QuickMenuItemKey.ActivityCreator, label: 'Tạo hoạt động sáng tạo', view: View.ActivityCreator, icon: <PuzzlePieceIcon className="h-5 w-5 text-indigo-500" /> },
    [QuickMenuItemKey.InteractiveVideo]: { key: QuickMenuItemKey.InteractiveVideo, label: 'Video tương tác', view: View.InteractiveVideo, icon: <BoltIcon className="h-5 w-5 text-teal-600" /> },
    [QuickMenuItemKey.DesignCenter]: { key: QuickMenuItemKey.DesignCenter, label: 'Thiết kế thông minh', view: View.DesignCenter, icon: <SparklesIcon className="h-5 w-5 text-violet-500" /> },
    [QuickMenuItemKey.ClassManagement]: { key: QuickMenuItemKey.ClassManagement, label: 'Quản lý lớp học', view: View.ClassManagement, icon: <UserGroupIcon className="h-5 w-5 text-sky-500" /> },
    [QuickMenuItemKey.SKKNCreator]: { key: QuickMenuItemKey.SKKNCreator, label: 'Sáng kiến kinh nghiệm', view: View.SKKNCreator, icon: <LightBulbIcon className="h-5 w-5 text-amber-500" /> },
    [QuickMenuItemKey.ScientificSimulationCreator]: { key: QuickMenuItemKey.ScientificSimulationCreator, label: 'Mô phỏng khoa học', view: View.ScientificSimulationCreator, icon: <BoltIcon className="h-5 w-5 text-teal-500" /> },
    [QuickMenuItemKey.ThietKe3DCreator]: { key: QuickMenuItemKey.ThietKe3DCreator, label: 'Thiết kế ứng dụng 3D', view: View.ThietKe3DCreator, icon: <SparklesIcon className="h-5 w-5 text-cyan-500" /> },
    [QuickMenuItemKey.DocumentLibrary]: { key: QuickMenuItemKey.DocumentLibrary, label: 'Thư viện của tôi', view: View.DocumentLibrary, icon: <Square2StackIcon className="h-5 w-5 text-gray-500" /> },
    [QuickMenuItemKey.SharedLibrary]: { key: QuickMenuItemKey.SharedLibrary, label: 'Thư viện cộng đồng', view: View.SharedLibrary, icon: <DocumentDuplicateIcon className="h-5 w-5 text-emerald-500" /> },
    [QuickMenuItemKey.ParentDashboard]: { key: QuickMenuItemKey.ParentDashboard, label: 'Bảng điều khiển phụ huynh', view: View.ParentDashboard, icon: <HomeIcon className="h-5 w-5 text-sky-500" /> },
    [QuickMenuItemKey.StudentDashboard]: { key: QuickMenuItemKey.StudentDashboard, label: 'Lộ trình học tập', view: View.StudentDashboard, icon: <FlagIcon className="h-5 w-5 text-blue-500" /> },
    [QuickMenuItemKey.Pronunciation]: { key: QuickMenuItemKey.Pronunciation, label: 'Luyện Phát Âm', view: View.Pronunciation, icon: <ChatBubbleLeftRightIcon className="h-5 w-5 text-teal-500" /> },
    [QuickMenuItemKey.HistoryStoryteller]: { key: QuickMenuItemKey.HistoryStoryteller, label: 'AI Lịch Sử', view: View.HistoryStoryteller, icon: <ScrollIcon className="h-5 w-5 text-amber-600" /> },
    [QuickMenuItemKey.LiteratureAssistant]: { key: QuickMenuItemKey.LiteratureAssistant, label: 'AI Văn học', view: View.LiteratureAssistant, icon: <ChatBubbleBottomCenterTextIcon className="h-5 w-5 text-indigo-500" /> },
    [QuickMenuItemKey.ScienceExplainer]: { key: QuickMenuItemKey.ScienceExplainer, label: 'AI Khoa học', view: View.ScienceExplainer, icon: <BeakerIcon className="h-5 w-5 text-cyan-500" /> },
    [QuickMenuItemKey.AIToolbox]: { key: QuickMenuItemKey.AIToolbox, label: 'Thư viện công cụ AI', view: View.AILab, icon: <BeakerIcon className="h-5 w-5 text-purple-500" /> },
    [QuickMenuItemKey.AILab]: { key: QuickMenuItemKey.AILab, label: 'Phòng Lab AI', view: View.AILab, icon: <BeakerIcon className="h-5 w-5 text-purple-500" /> },
    [QuickMenuItemKey.AIEthics]: { key: QuickMenuItemKey.AIEthics, label: 'Đạo đức AI', view: View.AIEthics, icon: <ShieldCheckIcon className="h-5 w-5 text-emerald-500" /> },
    [QuickMenuItemKey.AIFactCheck]: { key: QuickMenuItemKey.AIFactCheck, label: 'Kiểm chứng AI', view: View.AIFactCheck, icon: <MagnifyingGlassIcon className="h-5 w-5 text-blue-500" /> },
    [QuickMenuItemKey.CareerJourney]: { key: QuickMenuItemKey.CareerJourney, label: 'Hành trình khám phá', view: View.CareerJourney, icon: <FlagIcon className="h-5 w-5 text-violet-500" /> },
};

const MenuItem: React.FC<{ icon: React.ReactNode; label: string; onClick: () => void; iconOnly?: boolean; disabled?: boolean; disabledReason?: string }> = ({ icon, label, onClick, iconOnly, disabled = false, disabledReason }) => (
    <button 
        onClick={disabled ? undefined : onClick}
        disabled={disabled}
        className={`flex items-center rounded-md transition-colors ${iconOnly ? 'justify-center p-2' : 'w-full space-x-3 p-2.5'} ${disabled ? 'cursor-not-allowed text-gray-300 bg-gray-50' : 'text-gray-700 hover:bg-gray-100'}`}
        title={disabled ? disabledReason : (iconOnly ? label : undefined)}
    >
        {icon}
        {!iconOnly && <span className="text-sm font-medium">{label}</span>}
    </button>
);

const FloatingMenu: React.FC<FloatingMenuProps> = ({ user, onNavigate, onUpdateSettings, onSwitchRole, activeRoleConfig }) => {
    const [isExpanded, setIsExpanded] = useState(true);
    const [isIconOnly, setIsIconOnly] = useState(true);
    const [position, setPosition] = useState({ x: 0, y: window.innerHeight / 4 });
    const [isDragging, setIsDragging] = useState(false);
    const [offset, setOffset] = useState({ x: 0, y: 0 });
    const menuRef = useRef<HTMLDivElement>(null);
    const dragTimeoutRef = useRef<number | null>(null);

    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
        if (!menuRef.current) return;
        
        // Use a short timeout to distinguish between a click/double-click and a drag
        dragTimeoutRef.current = window.setTimeout(() => {
            setIsDragging(true);
            const rect = menuRef.current!.getBoundingClientRect();
            setOffset({
                x: e.clientX - rect.left,
                y: e.clientY - rect.top,
            });
        }, 150);
        
        e.preventDefault();
        e.stopPropagation();
    };

    const handleMouseMove = useCallback((e: MouseEvent) => {
        if (!isDragging || !menuRef.current) return;
        let newX = e.clientX - offset.x;
        let newY = e.clientY - offset.y;

        newX = Math.max(0, Math.min(newX, window.innerWidth - menuRef.current.offsetWidth));
        newY = Math.max(80, Math.min(newY, window.innerHeight - menuRef.current.offsetHeight - 16));

        setPosition({ x: newX, y: newY });
    }, [isDragging, offset]);

    const handleMouseUp = useCallback(() => {
        if (dragTimeoutRef.current) {
            clearTimeout(dragTimeoutRef.current);
            dragTimeoutRef.current = null;
        }
        setIsDragging(false);
    }, []);
    
    const handleDoubleClick = () => {
        if (dragTimeoutRef.current) {
            clearTimeout(dragTimeoutRef.current);
            dragTimeoutRef.current = null;
        }
        setIsExpanded(prev => !prev);
    };

    const handleCloseMenu = () => {
        onUpdateSettings(prev => ({ ...prev, showFloatingMenu: false }));
    };

    useEffect(() => {
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
            if (dragTimeoutRef.current) {
                clearTimeout(dragTimeoutRef.current);
            }
        };
    }, [handleMouseMove, handleMouseUp]);
    
    const roleDefaults: Record<string, { icon: React.ReactNode; title: string; items: FloatingQuickMenuItem[] }> = {
        teacher: {
            icon: <AcademicCapIcon className="h-5 w-5 text-teal-800" />,
            title: 'Công cụ Trợ giảng',
            items: ALL_QUICK_MENU_ITEMS_CONFIG.filter(item => item.roles.includes('teacher')).map(item => ALL_QUICK_MENU_ITEMS[item.key]).filter(Boolean) as FloatingQuickMenuItem[]
        },
        parent: {
            icon: <UserGroupIcon className="h-5 w-5 text-teal-800" />,
            title: 'Gia đình',
            items: (user.children || []).length > 0
                ? (user.children || []).map((child: Child) => ({
                    key: QuickMenuItemKey.StudentDashboard,
                    label: `Bé ${child.name}`,
                    view: View.ChildDashboard,
                    payload: { child },
                    icon: <UserCircleIcon className="h-5 w-5 text-sky-500" />
                }) as FloatingQuickMenuItem)
                : ALL_QUICK_MENU_ITEMS_CONFIG.filter(item => item.roles.includes('parent')).map(item => ALL_QUICK_MENU_ITEMS[item.key]).filter(Boolean)
        },
        student: {
            icon: <UserCircleIcon className="h-5 w-5 text-teal-800" />,
            title: 'Góc học tập',
            items: ALL_QUICK_MENU_ITEMS_CONFIG.filter(item => item.roles.includes('student')).map(item => ALL_QUICK_MENU_ITEMS[item.key]).filter(Boolean) as FloatingQuickMenuItem[]
        }
    };
    
    if (!activeRoleConfig.role) return null;
    
    const roleConfig = roleDefaults[activeRoleConfig.role] || roleDefaults.teacher;
    const customMenuItems = (user.quickMenuItems || [])
        .filter(item => {
            const config = ALL_QUICK_MENU_ITEMS_CONFIG.find(menuItem => menuItem.key === item.key);
            return !!config && config.roles.includes(activeRoleConfig.role as any);
        })
        .map(item => ALL_QUICK_MENU_ITEMS[item.key])
        .filter(Boolean) as FloatingQuickMenuItem[];
    const useCustomMenu = customMenuItems.length > 0;
    const affiliateMenuDisabledReason = user.authType === 'student_code'
        ? 'Tài khoản đăng nhập bằng mã học sinh không hỗ trợ bật kiếm tiền. Hãy dùng tài khoản cá nhân để tham gia Affiliate.'
        : undefined;
    const affiliateMenuItem: FloatingQuickMenuItem = {
        key: 'affiliate-dashboard',
        label: user.isAffiliateActive ? 'Trung tâm Affiliate' : 'Bật kiếm tiền',
        view: View.AffiliateDashboard,
        icon: <SparklesIcon className="h-5 w-5 text-amber-500" />,
        disabled: !!affiliateMenuDisabledReason,
        disabledReason: affiliateMenuDisabledReason,
    };
    const appendAffiliateMenuItem = (items: FloatingQuickMenuItem[]) => {
        if (items.some(item => item.key === affiliateMenuItem.key)) {
            return items;
        }
        return [...items, affiliateMenuItem];
    };
    const menuItems = appendAffiliateMenuItem(useCustomMenu ? customMenuItems : roleConfig.items);

    // Sắp xếp để 'Bảng điều khiển' luôn lên đầu
    const sortedItems = [...menuItems].sort((a, b) => {
        if (a.label === 'Bảng điều khiển' || a.label === 'Bảng điều khiển phụ huynh') return -1;
        if (b.label === 'Bảng điều khiển' || b.label === 'Bảng điều khiển phụ huynh') return 1;
        return 0;
    });

    const config = {
        ...roleConfig,
        items: sortedItems
    };

    if (!isExpanded) {
        return (
            <div
                ref={menuRef}
                style={{ top: position.y, left: position.x }}
                onMouseDown={handleMouseDown}
                onDoubleClick={handleDoubleClick}
                className="fixed z-40 w-12 h-12 bg-white/80 backdrop-blur-md rounded-r-full shadow-2xl border border-gray-200 flex items-center justify-center cursor-pointer hover:bg-teal-50"
                title="Nhấn đúp để mở/đóng Menu"
            >
                <BoltIcon className="h-6 w-6 text-teal-600" />
            </div>
        );
    }

    return (
        <div
            ref={menuRef}
            className={`fixed z-40 bg-white/80 backdrop-blur-md rounded-r-xl shadow-2xl border border-gray-200 flex flex-col transition-all duration-300 ${isIconOnly ? 'w-14' : 'w-64'}`}
            style={{ 
                top: position.y, 
                left: position.x,
                maxHeight: `calc(100vh - ${position.y}px - 20px)`
            }}
        >
            <div 
                className={`p-2 flex items-center border-b flex-shrink-0 cursor-move ${isIconOnly ? 'flex-col space-y-2' : 'justify-between'}`}
                onMouseDown={handleMouseDown}
                onDoubleClick={handleDoubleClick}
            >
                <div className={`flex items-center ${isIconOnly ? 'flex-col' : 'space-x-2'}`}>
                    <div className="bg-teal-100 p-1.5 rounded-md" title="Menu Nhanh"><BoltIcon className="h-5 w-5 text-teal-800" /></div>
                    {!isIconOnly && <h3 className="text-sm font-bold text-gray-700 select-none">Menu Nhanh</h3>}
                </div>
                <div className={`flex items-center ${isIconOnly ? 'flex-col space-y-1' : 'space-x-1'}`}>
                    <button 
                        onClick={() => setIsIconOnly(!isIconOnly)} 
                        className="p-1 rounded-md hover:bg-gray-200" 
                        title={isIconOnly ? "Hiện đầy đủ" : "Chỉ hiện Icon"}
                    >
                        {isIconOnly ? (
                            <ArrowDownIcon className="h-4 w-4 text-gray-600 transform -rotate-90" />
                        ) : (
                            <ChevronLeftIcon className="h-4 w-4 text-gray-600" />
                        )}
                    </button>
                    <button onClick={handleCloseMenu} className="p-1 rounded-md hover:bg-gray-200" title="Đóng menu">
                        <XMarkIcon className="h-4 w-4 text-gray-600" />
                    </button>
                    <button onClick={() => setIsExpanded(false)} className="p-1 rounded-md hover:bg-gray-200" title="Thu gọn">
                        <ArrowDownIcon className="h-4 w-4 text-gray-600" />
                    </button>
                </div>
            </div>
            
            <div className={`p-2 space-y-1 overflow-y-auto custom-scrollbar ${isIconOnly ? 'flex flex-col items-center' : ''}`}>
                {config.items.map((item, index) => (
                    <MenuItem 
                        key={item.key || index}
                        icon={item.icon}
                        label={item.label}
                        onClick={() => onNavigate(item.view, (item as any).payload || {})}
                        iconOnly={isIconOnly}
                        disabled={item.disabled}
                        disabledReason={item.disabledReason}
                    />
                ))}
                {activeRoleConfig.isTeacher && (
                    <>
                        <div className={`border-t border-gray-200 my-1 ${isIconOnly ? 'w-8' : 'mx-1'}`} />
                        <MenuItem
                            icon={<UserCircleIcon className="h-5 w-5 text-slate-600" />}
                            label="Cài đặt"
                            onClick={() => { onNavigate(View.Settings); setIsExpanded(false); }}
                            iconOnly={isIconOnly}
                        />
                        <MenuItem
                            icon={<UserGroupIcon className="h-5 w-5 text-teal-600" />}
                            label="Quản lý nhóm"
                            onClick={() => { onNavigate(View.Settings, { hash: 'quan-ly-nhom' }); setIsExpanded(false); }}
                            iconOnly={isIconOnly}
                        />
                        {onSwitchRole && activeRoleConfig.canSwitchRole && (
                            <MenuItem
                                icon={<UserCircleIcon className="h-5 w-5 text-orange-500" />}
                                label="Sang vai trò Phụ huynh"
                                onClick={() => onSwitchRole('parent')}
                                iconOnly={isIconOnly}
                            />
                        )}
                    </>
                )}
                {activeRoleConfig.isParent && activeRoleConfig.canSwitchRole && (
                    <>
                        <div className={`border-t border-gray-200 my-1 ${isIconOnly ? 'w-8' : 'mx-1'}`} />
                        {onSwitchRole && (
                            <MenuItem
                                icon={<AcademicCapIcon className="h-5 w-5 text-teal-600" />}
                                label="Về vai trò Giáo viên"
                                onClick={() => onSwitchRole('teacher')}
                                iconOnly={isIconOnly}
                            />
                        )}
                    </>
                )}
                    {activeRoleConfig.isParent && config.items.length === 0 && !useCustomMenu && (
                        <div className="p-2.5 text-xs text-center text-gray-500">
                        <p>Chưa có tài khoản nào của con.</p>
                        <button onClick={() => onNavigate(View.Dashboard)} className="font-semibold text-teal-600 hover:underline">Thêm tại Bảng điều khiển</button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FloatingMenu;